// ADDENDUM 33 (E39), punto 2 — el radio de los CONTROLES de la ficha, en un solo sitio.
//
// Hermano de `detailSurfaces.js` y por el mismo motivo: aquello nació porque había cuatro grises de
// dos familias incompatibles repartidos por el diálogo, y esto nace porque había tres radios de
// botón conviviendo — píldora (`999`) en los botones con texto, `2` en los de icono con borde y el
// 4 px por defecto de MUI en los demás. El PO lo vio como "los de arriba son más redondeados que
// los de cerrar", que es exactamente lo que pasaba.
//
// ⚠ El valor NO es nuevo: es el que YA usaban el botón de cerrar, el de los tres puntos y el del
// QR. Se elige ese y no otro porque el encargo era parecerse a lo que ya hay (mismo criterio del
// addendum 29), no diseñar un radio.
//
// ⚠ ALCANCE DECLARADO: esto unifica los DOCE botones que eran píldora con los TRES de icono con
// borde. Quedan fuera 18 `Button` que nunca declararon radio y corren con el 4 px por defecto de
// MUI (casi todos en `FabricationOrderDetailDialog`: navegación de bloques, reintentos, acciones de
// diálogo) y 7 `IconButton` que son CIRCULARES por el mismo defecto. Llevarlos también aquí es una
// decisión visual sobre toda la ventana, no el arreglo que el PO pidió, así que va reportada y no
// hecha. Mientras tanto la dispersión baja de tres radios a dos.
//
// En `sx` de MUI el número se multiplica por `theme.shape.borderRadius` (4 px por defecto), así que
// `2` son 8 px. Se deja como número de la escala y no como '8px' para que siga al tema si algún día
// se define uno propio.
export const CONTROL_RADIUS = 2
